import { lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// layout
import DashbordLayout from "./DashbordLayout";
import DashboardRoute from "./DashboardRoute";
// components
const HomePage = lazy(() => import("../../containers/HomePage"));
const OrderRequirementPage = lazy(() =>
  import("../../components/Smart/OrderRequirementPage")
);
const OrderRequirementDetailPage = lazy(() =>
  import("../../components/Smart/OrderRequirementDetailPage")
);
const TrackingPage = lazy(() => import("../../components/Smart/TrackingPage"));
const ListOrderRequirementPage = lazy(() =>
  import("../../components/Smart/ListOrderRequirementPage")
);
const TosPage = lazy(() => import("../../components/Smart/TosPage"));
const MasterPricePage = lazy(() =>
  import("../../components/Smart/MasterPricePage")
);
const MasterSafetyStockPage = lazy(() =>
  import("../../components/Smart/MasterSafetyStockPage")
);
const MasterSupplierPage = lazy(() =>
  import("../../containers/MasterSupplierPage")
);
const ForwardContractPage = lazy(() =>
  import("../../containers/ForwardContractPage")
);
const DateToWareHouseContainer = lazy(() =>
  import("../../components/Smart/DateToWareHouseContainer")
);
const ClaimCreationPage = lazy(() =>
  import("../../containers/ClaimCreatePage")
);
const ClaimSearchPage = lazy(() => import("../../containers/ClaimSearchPage"));
const ClaimDocumentPage = lazy(() =>
  import("../../containers/ClaimDocumentPage")
);
const ForexSearchPage = lazy(() => import("../../containers/ForexSearchPage"));
const ForexPage = lazy(() => import("../../containers/ForexPage"));
const AnnoucementPage = lazy(() => import("../../containers/AnnoucementPage"));
const AnnoucementDetailPage = lazy(() =>
  import("../../containers/AnnoucementDetailPage")
);
const ShipmentPage = lazy(() => import("../../containers/ShipmentPage"));
const MasterTb = lazy(() => import("../../containers/MasterTb"));
const MasterQualityProblemPage = lazy(() =>
  import("../../components/Smart/MasterQualityProblemPage")
);
const MasterNCRPage = lazy(() =>
  import("../../components/Smart/MasterNCRPage")
);
const MasterInlandCostPage = lazy(() =>
  import("../../containers/MasterInlandCostPage")
);
const ListTosPage = lazy(() => import("../../containers/ListTosPage"));
const SapPoPage = lazy(() => import("../../containers/SapPoPage"));
const RoleManagerPage = lazy(() => import("../../containers/RoleManagerPage"));
const AccountManagerPage = lazy(() =>
  import("../../containers/AccountManagerPage")
);
const ManagePoPage = lazy(() => import("../../containers/ManagePoPage"));
const MasterMaterialPoTextPage = lazy(() =>
  import("../../containers/MasterMaterialPoTextPage")
);
const MasterProductPicture = lazy(() =>
  import("../../containers/MasterProductPicture")
);
const DamageReport = lazy(() =>
  import("../../containers/DamangeReport/DamageReport")
);
const DamageReportSearch = lazy(() =>
  import("../../containers/DamangeReport/DamageReportSearch")
);
const DamageReportQaSearch = lazy(() =>
  import("../../containers/DamangeReport/DamageReportQaSearch")
);
const MasterDestinationPort = lazy(() =>
  import("../../containers/MasterDestinationPort")
);
const MasterGradeType = lazy(() => import("../../containers/MasterGradeType"));
const MasterInlandTrans = lazy(() =>
  import("../../containers/MasterInlandTrans")
);
const MasterConfig = lazy(() => import("../../containers/MasterConfig"));
const SearchShipmentNoGr = lazy(() =>
  import("../../containers/ShipmentSearchNoGrDate")
);
const MasterTosWorkflow = lazy(() =>
  import("../../containers/MasterTosWorkflowPage")
);

export default function DashbordLayoutRoute() {
  return (
    <DashbordLayout>
      <Switch>
        <DashboardRoute path="/" page="Home" component={HomePage} exact />
        <DashboardRoute
          path="/order/orderrequirement/:id?"
          page="Search Order Requirement"
          component={OrderRequirementPage}
          exact
        />
        <DashboardRoute
          path="/order/orderrequirementdetail/:id?"
          component={OrderRequirementDetailPage}
          page="Create Order Requirement"
          exact
        />
        <DashboardRoute
          path="/masterprice"
          component={MasterPricePage}
          page="Master Price"
          exact
        />
        <DashboardRoute
          path="/mastersafetystock"
          component={MasterSafetyStockPage}
          page="Master Safety Stock"
          exact
        />
        <DashboardRoute
          path="/tracking"
          component={TrackingPage}
          page="Os Tracking"
          exact
        />
        <DashboardRoute
          path="/tos/listorderrequirement/:id?"
          component={ListOrderRequirementPage}
          page="List Order Requirement"
          exact
        />
        <DashboardRoute
          path="/tos/listTos/:id?"
          component={ListTosPage}
          page="List Tos"
          exact
        />
        <DashboardRoute path="/tos/:id" component={TosPage} page="TOS" exact />
        <DashboardRoute
          path="/masterSupplier"
          component={MasterSupplierPage}
          page="Master Suplier"
          exact
        />
        <DashboardRoute
          path="/forex"
          component={ForexSearchPage}
          page="Forex"
          exact
        />
        <DashboardRoute
          path="/forex/:id"
          exact
          component={ForexPage}
          page="Forex Detail"
        />
        <DashboardRoute
          path="/forwardContract/:id/"
          component={ForwardContractPage}
          page="FowardContact Detail"
          exact
        />
        <DashboardRoute
          path="/shipmentDetail/:tosId(\d+)?/:lot?"
          component={ShipmentPage}
          page="Shipment Detail"
          exact
        />
        <DashboardRoute
          path="/dtwh"
          component={DateToWareHouseContainer}
          page="DTWH"
          exact
        />
        <DashboardRoute
          path="/claim/tracking/:id?"
          component={ClaimSearchPage}
          page="Tracking Claim"
          exact
        />
        <DashboardRoute
          path="/claim/document"
          component={ClaimDocumentPage}
          page="Document Claim"
          exact
        />
        <DashboardRoute
          path="/claim/ccr/:id(\d+)?"
          component={ClaimCreationPage}
          page="Create Claim CCR"
          exact
        />
        <DashboardRoute
          path="/claim/tos/:id(\d+)?"
          component={ClaimCreationPage}
          page="Create Claim Tos"
          exact
        />
        <DashboardRoute
          path="/claim/manual/:id(\d+)?"
          component={ClaimCreationPage}
          page="Create Claim Manual"
          exact
        />
        <DashboardRoute
          path="/annoucement"
          component={AnnoucementPage}
          page="Annoucement"
          exact
        />
        <DashboardRoute
          path="/annoucement/:id"
          component={AnnoucementDetailPage}
          page="AnnoucementDetail"
          exact
        />
        <DashboardRoute
          path="/masterTP"
          component={MasterTb}
          page="MasterTP"
          exact
        />
        <DashboardRoute
          path="/masterClaimProblem"
          component={MasterQualityProblemPage}
          page="MasterClaimProblem"
          exact
        />
        <DashboardRoute
          path="/masterNCR"
          component={MasterNCRPage}
          page="MasterNCR"
          exact
        />
        <DashboardRoute
          path="/masterInlandCost"
          component={MasterInlandCostPage}
          page="Master Inland Cost"
          exact
        />
        <DashboardRoute
          path="/sappo"
          component={SapPoPage}
          page="Sap PO"
          exact
        />
        <DashboardRoute
          path="/role"
          component={RoleManagerPage}
          page="Manage Role"
          exact
        />
        <DashboardRoute
          path="/account"
          component={AccountManagerPage}
          page="Manage Account"
          exact
        />
        <DashboardRoute
          path="/manualpo"
          component={ManagePoPage}
          page="Manual PO"
          exact
        />
        <DashboardRoute
          path="/masterMaterialPoText"
          component={MasterMaterialPoTextPage}
          page="Master Material Po Text"
          exact
        />
        <DashboardRoute
          path="/MasterProductDocument"
          exact
          component={MasterProductPicture}
          page="Master Product Document"
        />
        <DashboardRoute
          path="/DamageReportSearch"
          exact
          component={DamageReportSearch}
          page="Damage Report Search"
        />
        <DashboardRoute
          path="/DamageReportQaSearch"
          exact
          component={DamageReportQaSearch}
          page="Damage Report QA Search"
        />
        <DashboardRoute
          path="/DamageReport/:id(\d+)?/"
          component={DamageReport}
          page="Damage Report WH"
        />
        <DashboardRoute
          path="/DamageReportQa/:id(\d+)?/"
          component={DamageReport}
          page="Damage Report QA"
        />
        <DashboardRoute
          path="/MasterDestinationPort"
          component={MasterDestinationPort}
          page="Master Destination Port"
        />
        <DashboardRoute
          path="/MasterGradeType"
          component={MasterGradeType}
          page="Master Grade Type"
        />
        <DashboardRoute
          path="/MasterInlandTrans"
          component={MasterInlandTrans}
          page="Master Inland Trans"
        />
        <DashboardRoute
          path="/MasterConfig"
          component={MasterConfig}
          page="Master Config"
        />
        <DashboardRoute
          path="/MasterOrgConfig"
          component={MasterConfig}
          page="Master Organization Config"
        />
        <DashboardRoute
          path="/ShipmentGr"
          component={SearchShipmentNoGr}
          page="Shipment Gr"
        />
        <DashboardRoute
          path="/MasterTosWorkflow"
          component={MasterTosWorkflow}
          page="Master TOS Workflow"
        />

        <Route component={NotFoundRedirect} />
      </Switch>
    </DashbordLayout>
  );
}

function NotFoundRedirect() {
  return <Redirect to="/not-found" replacae />;
}
